import React, { Component, Fragment } from "react";
import ThresholdForm from "./ThresholdForm";
import DelayForm from "./DelayForm";
import ErrorForm from "./ErrorForm";

import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { InlineTimePicker } from "material-ui-pickers/TimePicker";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import httpr from "lib/httpRequest";

var moment = require("moment");

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

class MainForm extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      selectedLocationId: "",
      allTermsSelected: true,
      selectedTerminals: [],
      termsToSend: [],
      allDaysSelected: true,
      selectedDaysToNotify: ["All"],
      allDay: 1,
      selectedStartHour: new Date(),
      selectedEndHour: new Date(),
      openTillDelay: 10,
      errorDelay: 0,
      errorRepeats: 0,
      selectedErrorInterval: 0,
      selectedErrorAlert: "",
      replicationDelay: 24,
      minThreshold: 50,
      maxThreshold: 50,
      allCassettesSelected: true,
      selectedCassettes: ["All"],
      cassetteNamesToSend: ["All"],
      allDenomsSelected: true,
      selectedDenominations: ["All"],
      denomsToSend: ["All"],
      terminals: [],
      editSetupCass: false,
      editSetupDen: false,
      snackbarOpen: false,
      snackbarMsg: "",
      endTimeError: false,
    };

    if (this.props.edit) {
      this.props.Locations.map((locObj) => {
        if (
          locObj.LocationName ===
          this.props.editData.LocationName.replace(/ /g, "_")
        ) {
          this.state.selectedLocationId = locObj.LocationId;
        }
      });

      let dayIndexes = [];
      if (this.props.editData.DaysToNotify.includes("All")) {
        this.state.selectedDaysToNotify = ["All"];
      } else {
        this.props.editData.DaysToNotify.split(", ").map((day) => {
          dayIndexes.push(days.indexOf(day));
        });
        if (dayIndexes.length === days.length) {
          this.state.selectedDaysToNotify = ["All"];
        } else {
          this.state.selectedDaysToNotify = dayIndexes;
          this.state.allDaysSelected = false;
        }
      }

      this.state.allDay = this.props.editData.AllDay === "No" ? 0 : 1;

      let tempStart = moment(this.props.editData.StartHour, "HH:mm a").format();
      tempStart = new Date(moment(tempStart).toDate());

      let tempEnd = moment(this.props.editData.EndHour, "HH:mm a").format();
      tempEnd = new Date(moment(tempEnd).toDate());

      this.state.selectedStartHour = tempStart;
      this.state.selectedEndHour = tempEnd;

      this.state.minThreshold = this.props.editData.MinThreshold;
      this.state.maxThreshold = this.props.editData.MaxThreshold;
      this.state.openTillDelay = this.props.editData.OpenTillDelay;
      this.state.errorDelay = this.props.editData.ErrorDelay;
      this.state.errorRepeats = this.props.editData.ErrorRepeats;
      this.state.selectedErrorAlert = this.props.editData.ErrorAlertType;
      this.state.selectedErrorInterval = 
        this.props.editData.ErrorInterval === "Day" ? 0 
        : (this.props.editData.ErrorInterval === "Week" ? 1 
        : (this.props.editData.ErrorInterval === "Month" ? 2 : 3));
      this.state.replicationDelay = this.props.editData.ReplicationDelay;

      // tell threshold form that initial setup is happening
      if (this.props.type === "threshold") {
        this.state.editSetupCass = true;
        this.state.editSetupDen = true;
        // set denoms to send
        if (this.props.editData.DENOMINATION.includes("All")) {
          this.state.denomsToSend = ["All"];
        } else {
          this.state.denomsToSend = this.props.editData.DENOMINATION.split(",");
          this.state.allDenomsSelected = false;
        }

        // set cassettes to send
        if (this.props.editData.UNIT_ID.includes("All")) {
          this.state.cassetteNamesToSend = ["All"];
        } else {
          let cassToSend = this.props.editData.UNIT_ID.replace(/'/g, "''");
          this.state.cassetteNamesToSend = cassToSend.split(",");
          this.state.allCassettesSelected = false;
        }
      }
    }
  }

  /* LIFECYCLE FUNCTIONS */
  componentDidMount() {
    this._isMounted = true;
    // get terminals for each location member is part of
    this.getTerminals();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /* FETCH FUNCTIONS */
  getTerminals = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    const { Locations } = this.props;

    let locIds = [];

    Locations.map((loc) => {
      locIds.push(loc.LocationId);
    });

    fetch
      .post("/api/terminal/locations/", {
        locationIds: locIds,
      })
      .then((response) => {
        let rcmTerminalsOnly = response.data.terminals.filter(termObj => !termObj.TERMINAL_ID.toString().includes("K"));
        if (this._isMounted === true) {
          this.setState({
            terminals: rcmTerminalsOnly,
          });
        }
      })
      .then(() => {
        // if in edit, set selected terminals
        if (this.props.edit) {
          let temp = [];
          let incomingList = [];
          let length = 0;
          this.state.terminals.map((termObj, index) => {
            if (termObj.location.LocationId === this.state.selectedLocationId) {
              length = length + 1;
              // compare list of term ids to this term id
              incomingList = this.props.editData.RECYCLER_ID.split(", ");
              if (incomingList.includes(`${termObj.TERMINAL_ID}`)) {
                temp.push(index); // save index of this terminal from array
              }
            }
          });
          if (
            temp.length === length ||
            this.props.editData.RECYCLER_ID.includes("All")
          ) {
            if (this._isMounted === true) {
              this.setState({
                allTermsSelected: true,
                selectedTerminals: ["All"],
              });
            }
          } else {
            if (this._isMounted === true) {
              this.setState({
                allTermsSelected: false,
                selectedTerminals: temp,
              });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /* PREPOPULATE EDIT CARD FUNCTIONS */
  prePopCassettes = (cassettes) => {
    // get indexes from passed cassettes and set selectedCassettes
    if (this.props.editData.UNIT_ID.includes("All")) {
      if (this._isMounted === true) {
        this.setState({
          selectedCassettes: ["All"],
          allCassettesSelected: true,
          editSetupCass: false,
        });
      }
    } else {
      let selectedList = this.props.editData.UNIT_ID.replace(/'/g, "");
      selectedList = selectedList.split(",");
      let temp = [];
      cassettes.map((cassette, index) => {
        cassette = cassette.UNIT_ID;
        if (selectedList.includes(cassette)) {
          temp.push(index);
        }
      });
      if (this._isMounted === true) {
        this.setState({
          selectedCassettes: temp,
          allCassettesSelected: false,
          editSetupCass: false,
        });
      }
    }
  };

  prePopDenoms = (denoms) => {
    // get indexes from passed denoms and set selected
    if (this.props.editData.DENOMINATION.includes("All")) {
      if (this._isMounted === true) {
        this.setState({
          selectedDenominations: ["All"],
          allDenomsSelected: true,
          editSetupDen: false,
        });
      }
    } else {
      let selectedList = this.props.editData.DENOMINATION.split(",");
      let temp = [];
      denoms.map((obj, index) => {
        let denom = obj.NOTE_VALUE.replace("$", "");
        if (selectedList.includes(denom)) {
          temp.push(index);
        }
      });
      if (this._isMounted === true) {
        this.setState({
          selectedDenominations: temp,
          allDenomsSelected: false,
          editSetupDen: false,
        });
      }
    }
  };

  /* HANDLE FUNCTIONS */
  handleLocationSelected = (event) => {
    // set location and reset selected terminals
    this.setState({
      selectedLocationId: event.target.value,
      selectedTerminals: ["All"],
      allTermsSelected: true,
      selectedCassettes: ["All"],
      allCassettesSelected: true,
      selectedDenominations: ["All"],
      allDenomsSelected: true,
    });
  };

  handleTerminalSelected = (event) => {
    // if all is included in event.target.value
    if (event.target.value.includes("All")) {
      if (event.target.value.length < 2) {
        this.setState({
          allTermsSelected: true,
          selectedTerminals: ["All"],
          allCassettesSelected: true,
          selectedCassettes: ["All"],
          cassetteNamesToSend: ["All"],
          allDenomsSelected: true,
          selectedDenominations: ["All"],
          denomsToSend: ["All"],
        });
      } else {
        let index = event.target.value.indexOf("All");
        if (index === 0) {
          let selected = event.target.value;
          selected.splice(index, 1);
          this.setState({
            allTermsSelected: false,
            selectedTerminals: selected,
            allCassettesSelected: true,
            selectedCassettes: ["All"],
            cassetteNamesToSend: ["All"],
            allDenomsSelected: true,
            selectedDenominations: ["All"],
            denomsToSend: ["All"],
          });
        } else {
          this.setState({
            allTermsSelected: true,
            selectedTerminals: ["All"],
            allCassettesSelected: true,
            selectedCassettes: ["All"],
            cassetteNamesToSend: ["All"],
            allDenomsSelected: true,
            selectedDenominations: ["All"],
            denomsToSend: ["All"],
          });
        }
      }
    } else {
      if (event.target.value.length < 1) {
        this.setState({
          allTermsSelected: true,
          selectedTerminals: ["All"],
          allCassettesSelected: true,
          selectedCassettes: ["All"],
          cassetteNamesToSend: ["All"],
          allDenomsSelected: true,
          selectedDenominations: ["All"],
          denomsToSend: ["All"],
        });
      } else {
        this.setState({
          allTermsSelected: false,
          selectedTerminals: event.target.value,
          allCassettesSelected: true,
          selectedCassettes: ["All"],
          cassetteNamesToSend: ["All"],
          allDenomsSelected: true,
          selectedDenominations: ["All"],
          denomsToSend: ["All"],
        });
      }
    }
  };

  handleSelectedCassettes = (cassettes) => (event) => {
    // if all is included in event.target.value
    if (event.target.value.includes("All")) {
      if (event.target.value.length < 2) {
        this.setState({
          allCassettesSelected: true,
          selectedCassettes: ["All"],
          allDenomsSelected: true,
          selectedDenominations: ["All"],
          denomsToSend: ["All"],
        });
      } else {
        let index = event.target.value.indexOf("All");
        if (index === 0) {
          let selected = event.target.value;
          selected.splice(index, 1);
          this.setState({
            allCassettesSelected: false,
            selectedCassettes: selected,
            allDenomsSelected: true,
            selectedDenominations: ["All"],
            denomsToSend: ["All"],
          });
        } else {
          this.setState({
            allCassettesSelected: true,
            selectedCassettes: ["All"],
            allDenomsSelected: true,
            selectedDenominations: ["All"],
            denomsToSend: ["All"],
          });
        }
      }
    } else {
      if (event.target.value.length < 1) {
        this.setState({
          allCassettesSelected: true,
          selectedCassettes: ["All"],
          allDenomsSelected: true,
          selectedDenominations: ["All"],
          denomsToSend: ["All"],
        });
      } else {
        this.setState({
          allCassettesSelected: false,
          selectedCassettes: event.target.value,
          allDenomsSelected: true,
          selectedDenominations: ["All"],
          denomsToSend: ["All"],
        });
      }
    }

    this.setCassettesToSend(cassettes, event.target.value);
  };

  setCassettesToSend = (cassettes, value) => {
    // Prep a list of cassettes to send to api
    let list = [];
    // get names of cassettes save to list and set state
    if (value.includes("All") || value.length === 0) {
      this.setState({ cassetteNamesToSend: ["All"] });
    } else {
      // send selected cassettes
      value.map((i) => {
        let n = cassettes[i].UNIT_ID;
        n = `''${n}''`;
        list.push(n);
      });
      this.setState({ cassetteNamesToSend: list });
    }
  };

  handleDenominationsSelected = (denominations) => (event) => {
    if (event.target.value.includes("All")) {
      if (event.target.value.length < 2) {
        this.setState({
          allDenomsSelected: true,
          selectedDenominations: ["All"],
        });
      } else {
        let index = event.target.value.indexOf("All");
        if (index === 0) {
          let selected = event.target.value;
          selected.splice(index, 1);
          this.setState({
            allDenomsSelected: false,
            selectedDenominations: selected,
          });
        } else {
          this.setState({
            allDenomsSelected: true,
            selectedDenominations: ["All"],
          });
        }
      }
    } else {
      if (event.target.value.length < 1) {
        this.setState({
          allDenomsSelected: true,
          selectedDenominations: ["All"],
        });
      } else {
        this.setState({
          allDenomsSelected: false,
          selectedDenominations: event.target.value,
        });
      }
    }

    this.setDenomsToSend(denominations, event.target.value);
  };

  setDenomsToSend = (denominations, value) => {
    // Prep list of denominations to send to api
    let list = [];
    if (value.includes("All") || value.length === 0) {
      this.setState({ denomsToSend: ["All"] });
    } else {
      value.map((i) => {
        let n = denominations[i].NOTE_VALUE.split("$")[1];
        n = `${n}`;
        list.push(n);
        this.setState({ denomsToSend: list });
      });
    }
  };

  handleMinThresholdChanged = (event) => {
    let validatedEvent = event;
    if (event < 0 || event === null){
      validatedEvent = 0;
    } else if (event > 3000){
      validatedEvent = 3000;
    }
    this.setState({ minThreshold: validatedEvent });

  };

  handleMaxThresholdChanged = (event) => {
    let validatedEvent = event;
    if (event < 0 || event === null){
      validatedEvent = 0;
    } else if (event > 3000){
      validatedEvent = 3000;
    }
    this.setState({ maxThreshold: validatedEvent });
  };

  handleDaySelected = (event) => {
    // if all is included in event.target.value, remove it before saving
    if (event.target.value.includes("All")) {
      if (event.target.value.length < 2) {
        this.setState({ allDaysSelected: true, selectedDaysToNotify: ["All"] });
      } else {
        let index = event.target.value.indexOf("All");
        if (index === 0) {
          let selected = event.target.value;
          selected.splice(index, 1);
          this.setState({
            allDaysSelected: false,
            selectedDaysToNotify: selected,
          });
        } else {
          this.setState({
            allDaysSelected: true,
            selectedDaysToNotify: ["All"],
          });
        }
      }
    } else {
      if (event.target.value.length < 1) {
        this.setState({ allDaysSelected: true, selectedDaysToNotify: ["All"] });
      } else {
        this.setState({
          allDaysSelected: false,
          selectedDaysToNotify: event.target.value,
        });
      }
    }
  };
  handleAllDayToggle = (event) => {
    let allDay = this.state.allDay === 1 ? 0 : 1;
    this.setState({
      allDay: allDay,
    });
  };

  handleStartTimeChange = (date) => {
    this.setState({ selectedStartHour: date });
  };

  handleEndTimeChange = (date) => {
    if (date < this.state.selectedStartHour) {
      this.setState({ endTimeError: true });
      this.showNotification("End time must be later than start time");
    } else {
      this.setState({ selectedEndHour: date, endTimeError: false });
    }
  };

  handleOpenTillDelayChange = (OpenTillDelay) => {
    let validatedDelay = OpenTillDelay;
    if (OpenTillDelay < 1) {
      validatedDelay = 1;
    } else if (OpenTillDelay > 24) {
      validatedDelay = 24;
    }
    this.setState({ openTillDelay: validatedDelay });
  };

  handleErrorDelayChange = (ErrorDelay) => {
    let validatedDelay = ErrorDelay;
    if (ErrorDelay < 0) {
      validatedDelay = 0;
    } else if (ErrorDelay > 24) {
      validatedDelay = 24;
    }
    this.setState({ errorDelay: validatedDelay });
  };

  handleErrorRepeatsChange = (ErrorRepeats) => {
    let validatedRepeats = ErrorRepeats;
    if (ErrorRepeats < 0) {
      validatedRepeats = 0;
    } else if (ErrorRepeats > 24) {
      validatedRepeats = 24;
    }
    this.setState({ errorRepeats: validatedRepeats });
  };

  handleErrorIntervalChange = (event) => {
    this.setState({ selectedErrorInterval: event.target.value });
  }

  handleErrorAlertChange = (event) => {
    this.setState({ selectedErrorAlert: event.target.value });
  }

  handleReplicationDelayChange = (ReplicationDelay) => {
    let validatedDelay = ReplicationDelay;
    if (ReplicationDelay < 1) {
      validatedDelay = 1;
    } else if (ReplicationDelay > 24) {
      validatedDelay = 24;
    }
    this.setState({ replicationDelay: validatedDelay });
  };

  handleSaveAlert = () => {
    // get list of terminals
    let terminalList = [];
    if (!this.state.allTermsSelected) {
      this.state.selectedTerminals.map((i) => {
        terminalList.push(`${this.state.terminals[i].TERMINAL_ID}`);
      });
      terminalList = terminalList.join();
    } else {
      terminalList = ["All"];
    }

    // get list of days
    let dayList = [];
    if (!this.state.allDaysSelected) {
      this.state.selectedDaysToNotify.map((i) => {
        dayList.push(days[i]);
      });
      dayList = dayList.join();
    } else {
      dayList = ["All"];
    }

    // set start/end hour to 00:00:00 if All day is selected
    let startHour = this.state.selectedStartHour;
    let endHour = this.state.selectedEndHour;
    if (this.state.allDay === 1) {
      startHour.setHours(0, 0, 0, 0);
      endHour.setHours(23, 59, 0, 0);
    }
    startHour = moment(startHour).format("HH:mm");
    endHour = moment(endHour).format("HH:mm");

    // add all selected settings to an object
    let chosenSettings = {
      MemberId: this.props.member.MemberId,
      Type: this.props.type,
      ErrorAlertType: this.props.type === "error" ? this.state.selectedErrorAlert : "",
      RECYCLER_ID: terminalList,
      DaysToNotify: dayList,
      StartHour: startHour,
      EndHour: endHour,
      MinThreshold: this.state.minThreshold,
      MaxThreshold: this.state.maxThreshold,
      OpenTillDelay: this.state.openTillDelay,
      ErrorDelay: this.state.errorDelay,
      ErrorInterval: this.state.selectedErrorInterval,
      ErrorRepeats: this.state.errorRepeats,
      ReplicationDelay: this.state.replicationDelay,
      AllDay: this.state.allDay,
      UNIT_ID:
        this.state.cassetteNamesToSend.length > 0
          ? this.state.cassetteNamesToSend
          : ["All"],
      DENOMINATION:
        this.state.denomsToSend.length > 0 ? this.state.denomsToSend : ["All"],
      LocationID: this.state.selectedLocationId,
    };

    // send that object to backend
    this.props.edit
      ? this.props.updateAlertSettings(this.props.editData.ID, chosenSettings)
      : this.props.saveAlertSettings(chosenSettings);
  };

  /* SELECT DROPDOWN RENDER FUNCTIONS */
  renderSelectedTerminalValues = (event) => {
    const { terminals } = this.state;
    if (this.state.selectedLocationId > 0 && event.includes("All")) {
      return "All";
    }
    // if multiple
    if (event.length > 1) {
      let list = [];
      let term;
      event.map((terminalIndex) => {
        term = terminals[terminalIndex];
        list.push(term.TERMINAL_NAME);
      });

      return `${term.location.LocationName.replace(/_/g, " ")} - ${list.join(
        ", "
      )}`;
    } else {
      // if only one selected:
      if (terminals[event]) {
        const term = terminals[event];
        return `${term.location.LocationName.replace(/_/g, " ")} - ${
          term.TERMINAL_NAME
        }`;
      }
    }

    return "";
  };

  renderSelectedDayValues = (event) => {
    if (event.includes("All")) {
      return "All";
    }
    // if multiple
    if (event.length > 1) {
      let list = [];
      let day;
      event.map((i) => {
        day = days[i];
        list.push(day);
      });
      return list.join(", ");
    } else {
      // if only one
      if (days[event]) {
        const day = days[event];
        return day;
      }
    }
  };

  showNotification = (msg) => {
    this.setState({
      snackbarOpen: true,
      snackbarMsg: msg,
    });
  };

  render() {
    const { classes, member, Locations } = this.props;
    const { terminals } = this.state;
    const locations = Locations;

    /* SETUP SELECT LISTS */
    // Debug: Check if license data is being passed through
    
    let locationList = locations.map((location) => {
      // Check if location license is expired
      // Note: null/missing license data is treated as valid (isValid: 1)
      const isExpired = location.license && location.license.isValid === 0;
      const isExpiringSoon = location.license && 
                            location.license.isValid === 1 && 
                            location.license.daysUntilExpiration !== null &&
                            location.license.daysUntilExpiration <= 30 &&
                            location.license.daysUntilExpiration > 0;
      
      // Create location name with license status indicator
      let locationName = location.LocationName.replace(/_/g, " ");
      if (isExpired) {
        locationName = `🔒 ${locationName} (Expired)`;
      } else if (isExpiringSoon) {
        locationName = `⚠️ ${locationName} (${location.license.daysUntilExpiration} days)`;
      }
      
      return (
        <MenuItem 
          key={location.LocationId} 
          value={location.LocationId}
          disabled={isExpired}
          title={isExpired ? "License expired - Contact Socal Safe for renewal" : 
                 isExpiringSoon ? `License expires in ${location.license.daysUntilExpiration} days - Contact Socal Safe for renewal` : 
                 null}
        >
          <ListItemText primary={locationName} />
        </MenuItem>
      );
    });

    let terminalList;
    if (this.state.selectedLocationId < 0) {
      terminalList = (
        <MenuItem key={0} value={0} disabled>
          <ListItemText primary={"Please select a location first"} />
        </MenuItem>
      );
    } else {
      terminalList = terminals.map((terminal, index) => {
        //only show terminals based on selected location
        if (terminal.location.LocationId === this.state.selectedLocationId) {
          return (
            <MenuItem key={index} value={index}>
              <Checkbox
                checked={this.state.selectedTerminals.indexOf(index) > -1}
              />
              <ListItemText
                primary={`${terminal.location.LocationName.replace(
                  /_/g,
                  " "
                )} - ${terminal.TERMINAL_NAME}`}
              />
            </MenuItem>
          );
        }
      });
    }

    let dayMenu = days.map((day, index) => (
      <MenuItem key={index} value={index}>
        <Checkbox
          checked={this.state.selectedDaysToNotify.indexOf(index) > -1}
        />
        <ListItemText primary={day} />
      </MenuItem>
    ));

    /* Card Header */
    let type = this.props.type === "openTill" ? "open till" : this.props.type;
    let cardTitle = this.props.edit
      ? `Edit ${type} alert`
      : `Create ${type} alert`;

    return (
      <Card>
        <Snackbar
          place="tc"
          color="danger"
          icon={ErrorOutlineIcon}
          message={this.state.snackbarMsg}
          open={this.state.snackbarOpen}
          closeNotification={() => this.setState({ snackbarOpen: false })}
        />
        <CardHeader color="success">
          <h4 className={classes.cardTitleWhite}>{cardTitle}</h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="select-multiple-checkbox">
                  Select Location
                </InputLabel>
                <Select
                  name="selectedLocId"
                  value={this.state.selectedLocationId}
                  onChange={this.handleLocationSelected}
                  input={<Input id="select-multiple-checkbox" />}
                  MenuProps={MenuProps}
                >
                  {locationList}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="select-multiple-checkbox">
                  Select Terminals
                </InputLabel>
                <Select
                  name="selectedTermIds"
                  multiple={true}
                  value={this.state.selectedTerminals}
                  onChange={this.handleTerminalSelected}
                  input={<Input id="select-multiple-checkbox" />}
                  renderValue={this.renderSelectedTerminalValues}
                  MenuProps={MenuProps}
                >
                  {this.state.selectedLocationId > 0 && (
                    <MenuItem value={"All"}>
                      <Checkbox checked={this.state.allTermsSelected} />
                      <ListItemText primary={"All"} />
                    </MenuItem>
                  )}
                  {terminalList}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          {this.props.type === "threshold" ? (
            <ThresholdForm
              edit={this.props.edit}
              editSetupCass={this.state.editSetupCass}
              editSetupDen={this.state.editSetupDen}
              classes={this.props.classes}
              minThreshold={this.state.minThreshold}
              maxThreshold={this.state.maxThreshold}
              prePopCassettes={this.prePopCassettes}
              prePopDenoms={this.prePopDenoms}
              allCassettesSelected={this.state.allCassettesSelected}
              selectedCassettes={this.state.selectedCassettes}
              selectedLocationId={this.state.selectedLocationId}
              handleSelectedCassettes={this.handleSelectedCassettes}
              terminals={this.state.terminals}
              selectedTerminals={this.state.selectedTerminals}
              allDenomsSelected={this.state.allDenomsSelected}
              selectedDenominations={this.state.selectedDenominations}
              handleMinThresholdChanged={this.handleMinThresholdChanged}
              handleMaxThresholdChanged={this.handleMaxThresholdChanged}
              handleDenominationsSelected={this.handleDenominationsSelected}
            />
          ) : (this.props.type !== "error" ? (
            <DelayForm
              openTillDelay={this.state.openTillDelay}
              replicationDelay={this.state.replicationDelay}
              handleOpenTillDelayChange={this.handleOpenTillDelayChange}
              handleReplicationDelayChange={this.handleReplicationDelayChange}
              type={this.props.type}
            />
          ) : (
            <ErrorForm 
              classes={this.props.classes}
              selectedErrorAlert={this.state.selectedErrorAlert}
              handleErrorAlertChange={this.handleErrorAlertChange}
              errorDelay={this.state.errorDelay}
              handleErrorDelayChange={this.handleErrorDelayChange}
              errorRepeats={this.state.errorRepeats}
              handleErrorRepeatsChange={this.handleErrorRepeatsChange}
              selectedErrorInterval={this.state.selectedErrorInterval}
              handleErrorIntervalChange={this.handleErrorIntervalChange}
              type={this.props.type}
            />
          )) }
        <br/>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="select-multiple-checkbox">
                  Select Days To Notify
                </InputLabel>
                <Select
                  name="DaysToNotify"
                  multiple={true}
                  value={this.state.selectedDaysToNotify}
                  input={<Input id="select-multiple-checkbox" />}
                  renderValue={this.renderSelectedDayValues}
                  onChange={this.handleDaySelected}
                  MenuProps={MenuProps}
                >
                  <MenuItem value={"All"}>
                    <Checkbox checked={this.state.allDaysSelected} />
                    <ListItemText primary={"All"} />
                  </MenuItem>
                  {dayMenu}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.allDay === 1 ? true : false}
                    onChange={this.handleAllDayToggle}
                  />
                }
                label="All Day"
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <FormControl className={classes.formControl}>
                <div className="picker">
                  <InlineTimePicker
                    disabled={this.state.allDay === 1 ? true : false}
                    label="Start Time"
                    value={this.state.selectedStartHour}
                    onChange={this.handleStartTimeChange}
                    style={{
                      width: "100%",
                    }}
                  />
                </div>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <FormControl className={classes.formControl}>
                <Fragment>
                  <div className="picker">
                    <InlineTimePicker
                      disabled={this.state.allDay === 1 ? true : false}
                      label="End Time"
                      value={this.state.selectedEndHour}
                      onChange={this.handleEndTimeChange}
                      error={this.state.endTimeError}
                      style={{
                        width: "100%",
                      }}
                    />
                  </div>
                </Fragment>
              </FormControl>
            </GridItem>
          </GridContainer>
          <br />
        </CardBody>
        <CardFooter>
          <Button color="success" onClick={this.handleSaveAlert}>
            Save
          </Button>
          {this.props.edit === true && (
            <Button color="transparent" onClick={this.props.handleEditClose}>
              Cancel
            </Button>
          )}
        </CardFooter>
      </Card>
    );
  }
}
export default MainForm;



// WEBPACK FOOTER //
// ./src/components/Alerts/MainForm.jsx